import { useTranslation } from "react-i18next";
import { Award, Crown, Flame, Feather, Users } from "lucide-react";

const BADGE_ICON = {
    first_cycle: Award,
    streak_3: Flame,
    critic: Feather,
    founder: Crown,
    mentor: Users,
};

export default function BadgePill({ code }) {
    const { t } = useTranslation();
    const Icon = BADGE_ICON[code] || Award;
    return (
        <span
            data-testid={`badge-${code}`}
            className="inline-flex items-center gap-1.5 border border-[var(--accent)] text-[var(--accent)] rounded-full px-3 py-1 text-[10px] uppercase tracking-widest"
            title={t(`clubs.badge_${code}_desc`)}
        >
            <Icon size={11} strokeWidth={1.8} />
            {t(`clubs.badge_${code}`)}
        </span>
    );
}
